export default __webpack_public_path__ + "static/image1-efdadbf243f99199ff2bb051b187b1d2.webp";